import { render, staticRenderFns } from "./WorkflowIndexActions.vue?vue&type=template&id=3642dc1c&"
import script from "./WorkflowIndexActions.vue?vue&type=script&lang=js&"
export * from "./WorkflowIndexActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports